const resetFilterHandler = () => {
  const form = document.querySelector('form[name="arFilter_form"]');

  if (!form) {
    return;
  }

  const resetButton = document.querySelector('[data-reset-button]');
  const filterResetButtons = document.querySelectorAll('[data-filter="reset"]');
  const inputs = form.querySelectorAll('input');

  let formData = new FormData(form);
  let formDataLength = Array.from(formData.keys()).length;
  let priceMin = formData.has('arFilter_P1_MIN') && formData.get('arFilter_P1_MIN') !== '';
  let priceMax = formData.has('arFilter_P1_MAX') && formData.get('arFilter_P1_MAX') !== '';

  resetButton.addEventListener('click', (evt) => {
    evt.preventDefault();

    inputs.forEach((input) => {
      switch (input.type) {
        case 'number':
          if (input.value) {
            input.value = '';
            input.dispatchEvent(new Event('keyup'));
          }
          break;
        case 'checkbox':
          if (input.checked) {
            input.checked = false;
            input.dispatchEvent(new Event('click'));
          }
          break;
      }
    });

    filterResetButtons.forEach((filterResetButton) => {
      filterResetButton.style.display = 'none';
    });

    resetButton.classList.remove('is-active');
  });

  const resetFilterVisibility = () => {
    if (formDataLength > 2 || formDataLength === 2 && (priceMin || priceMax)) {
      if (!resetButton.classList.contains('is-active')) {
        resetButton.classList.add('is-active');
      }
    } else {
      resetButton.classList.remove('is-active');
    }
  };

  resetFilterVisibility();

  form.addEventListener('change', () => {
    formData = new FormData(form);
    formDataLength = Array.from(formData.keys()).length;
    priceMin = formData.has('arFilter_P1_MIN') && formData.get('arFilter_P1_MIN') !== '';
    priceMax = formData.has('arFilter_P1_MAX') && formData.get('arFilter_P1_MAX') !== '';

    resetFilterVisibility();
  });
};

export {resetFilterHandler};
